// IE 2026 10 08 / ODOO-5800 (заказ Игоря): чипс привязан к КОНКРЕТНОЙ записи виджета (chip.doc.widget) — открывать её и строить
// список подбора по ней ЯВНО, без подмены «Я»/«Всі» (USER.settings_defaults / doc.default_variant) бэком
// (common_modules/widgets.py → settings_variants.resolve_default_variant уважает widget_init.variant_explicit).
// Список значений стола по чипсу (workspaces.py) и так идёт по id — эта правка выравнивает фронт с ним.
// Выключатель fe.ux.chipWidgetExplicit (дефолт ВКЛ): false → прежнее поведение (подмена).

/** Аргументы store.widget_open для виджета чипса: { widget, variant_explicit: true, ...extra }; без id — null. */
export function chipWidgetOpenArgs(widget, extra = null, explicit = true) {
    const id = widget == null ? '' : String(widget).trim()
    if (!id) return null
    const args = { widget: id, ...(extra && typeof extra === 'object' ? extra : {}) }
    if (explicit !== false) args.variant_explicit = true
    return args
}

/** Флаг fe.ux.chipWidgetExplicit из стора (store.setting(key, true) !== false — как соседние выключатели); без стора — включён. */
export function chipWidgetExplicit_on(store) {
    try { return !store || typeof store.setting !== 'function' || store.setting('fe.ux.chipWidgetExplicit', true) !== false } catch (e) { return true }
}

/** Открыть виджет чипса через store.widget_open явно по привязанной записи; вернёт переданные аргументы или null (нет id / стора). */
export function chipWidget_open(store, widget, extra = null) {
    const args = chipWidgetOpenArgs(widget, extra, chipWidgetExplicit_on(store))
    if (!args || !store || typeof store.widget_open !== 'function') return null
    store.widget_open(args)
    return args
}

/** Явное открытие (variant_explicit, без record): уже открытое окно той же основной, в котором бэк подменил запись «Я»/«Всі»
 *  (ex.record.id ≠ WIDGET.widget), — НЕ то, что просили: findWidget_byProps его пропускает, открывается своё окно. */
export function chipWidget_skipSubstituted(WIDGET, ex) {
    if (!WIDGET || !WIDGET.variant_explicit || WIDGET.record?.id) return false
    const rid = ex?.record?.id
    return !!rid && rid !== WIDGET.widget
}

/** Источник подбора чипса (chipPick_widget): окно записи widgetId; окно той же основной с подменённой записью (record.id ≠ widgetId)
 *  при explicit — не источник (список подбора строился бы по чужой записи); без ответа бэка (record ещё нет) — кандидат. */
export function chipWidget_isSource(w, widgetId, explicit = true) {
    if (!w || w.close || !widgetId) return false
    const rid = w.record?.id
    if (rid === widgetId) return true
    if (w.widget !== widgetId) return false
    return !explicit || !rid
}
